export default __webpack_public_path__ + "static/media/StaffIcon.371e9db3.svg";